import React from "react";
import { capitalizeFirstLetter } from "../../../utils/letters";

export default function PortalHeaderIcons({
    messageUnreadCount = 0,
    notifUnreadCount = 0,
    notifOpen = false,
    notifications = [],
    chatDrawerOpen = false,
    onOpenChat,
    onToggleNotif,
    onCloseNotifBackdrop,
    onMarkRead,
    onMarkAllRead,
}) {
    const formatNotifDate = (iso) => {
        if (!iso) return "";
        const d = new Date(iso);
        return d.toLocaleDateString("es-CL", {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    return (
        <div className="av-icons-container teacher-portal-header-icons">
            <div className="av-icon-box av-chat-wrap">
                <button
                    type="button"
                    className="av-chat-trigger"
                    onClick={onOpenChat}
                    aria-label={
                        messageUnreadCount
                            ? `${messageUnreadCount} mensajes sin leer`
                            : "Mensajes de cursos"
                    }
                    aria-expanded={chatDrawerOpen}
                >
                    <i className="ri-chat-3-fill av-main-icon" aria-hidden />
                    {messageUnreadCount > 0 && (
                        <span className="av-dot-notif av-notif-badge av-chat-badge">
                            {messageUnreadCount > 99 ? "99+" : messageUnreadCount}
                        </span>
                    )}
                </button>
            </div>
            <div className={`av-icon-box av-notif-wrap ${notifOpen ? "open" : ""}`}>
                <button
                    type="button"
                    className="av-notif-trigger"
                    onClick={onToggleNotif}
                    aria-label={
                        notifUnreadCount
                            ? `${notifUnreadCount} notificaciones sin leer`
                            : "Notificaciones"
                    }
                    aria-expanded={notifOpen}
                >
                    <i className="ri-notification-2-fill av-main-icon" aria-hidden />
                    {notifUnreadCount > 0 && (
                        <span className="av-dot-notif av-notif-badge">
                            {notifUnreadCount > 99 ? "99+" : notifUnreadCount}
                        </span>
                    )}
                </button>
                {notifOpen && (
                    <>
                        <div
                            className="av-notif-backdrop"
                            onClick={onCloseNotifBackdrop}
                            aria-hidden
                        />
                        <div className="av-notif-dropdown" role="dialog" aria-label="Notificaciones">
                            <div className="av-notif-dropdown-header">
                                <h5 className="mb-0">Notificaciones</h5>
                                {notifUnreadCount > 0 && (
                                    <button
                                        type="button"
                                        className="av-notif-mark-all"
                                        onClick={onMarkAllRead}
                                    >
                                        <span className="fs-6 text-muted fw-normal">
                                            Marcar todas leidas
                                        </span>
                                    </button>
                                )}
                            </div>
                            <ul className="av-notif-list">
                                {notifications.length === 0 ? (
                                    <li className="av-notif-item av-notif-empty">
                                        No hay notificaciones
                                    </li>
                                ) : (
                                    notifications.map((n) => (
                                        <li
                                            key={n.id}
                                            className={`av-notif-item ${n.is_read ? "" : "unread"}`}
                                        >
                                            <button
                                                type="button"
                                                className="av-notif-item-btn"
                                                onClick={() => onMarkRead?.(n.id)}
                                            >
                                                <span className="av-notif-item-title">
                                                    {capitalizeFirstLetter(n.title)}
                                                </span>
                                                <p className="av-notif-item-message">
                                                    {capitalizeFirstLetter(n.message)}
                                                </p>
                                                <time className="av-notif-item-time">
                                                    {formatNotifDate(n.created_at)}
                                                </time>
                                            </button>
                                        </li>
                                    ))
                                )}
                            </ul>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
